import * as React from 'react';
import * as classNames from 'classnames';
import {StatelessComponent  } from 'react';
import './styles.sass';

interface IVideoSettingsCameraPreviewProps {
  mediaElementRef?: (node: HTMLVideoElement) => void;
  disabled: boolean;
}

export const VideoSettingsCameraPreview: StatelessComponent<IVideoSettingsCameraPreviewProps> = ({
  mediaElementRef,
  disabled,
}) => (
  <div className={
    classNames('video-settings-camera-preview', {
      'video-settings-camera-preview_disabled': disabled,
    })
  }>
    <video
      className={'video-settings-camera-preview__media'}
      autoPlay={true}
      preload={'none'}
      ref={mediaElementRef}
    />
  </div>
);
